const LOBCodes = [
  { value: 1, description: 'Individual', disabled: true },
  { value: 2, description: 'Government – contracting state / political subdivision / local authority' },
  { value: 3, description: 'Tax exempt pension trust / Pension fund' },
  { value: 4, description: 'Tax exempt / Charitable organization' },
  { value: 5, description: 'Publicly traded corporation' },
  { value: 6, description: 'Subsidiary of publicly traded corporation' },
  { value: 7, description: 'Company that meets the ownership and base erosion test' },
  { value: 8, description: 'Company that meets the derivative benefits test' },
  { value: 9, description: 'Company with an item of income that meets the active trade or business test' },
  { value: 10, description: 'Discretionary determination' },
  { value: 11, description: 'Other' }
];

export default LOBCodes;
